import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getAllUsers } from "../../controller/users/usersController"
import { AllUsersContainer } from "../../components";

const Accounts = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAllUsers());
    }, [dispatch]);

    return (
        <div>
            <AllUsersContainer />
        </div>
    )
};
export default Accounts;